<div
    [id]="id + '.' + filter.id"
    class="agpr-filterDateQuery"
>
    <agpr-date-query-popup
        [id]="id + '_filterDateQuery_' + filter.id"
        class="agpr-filterDateQuery-popup"
        [options]="filter.options"
        [hideDateTypeSelection]="true"
        [(ngModel)]="value"
        (ngModelChange)="handleChange()"
    ></agpr-date-query-popup>
</div>
